const getTransparentColor = (rgbColor, transparency) => {
    return rgbColor
        .replace("rgb", "rgba")
        .replace(")", "")
        .concat(`, ${transparency})`)
}

export default getTransparentColor